import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MmppProductsService {

  constructor(
    private http: HttpClient
  ) { }

  getMmppProducts() {
    return (this.http.get(`${environment.apiUrl}/mmpp-products`));
  }

  createMmppProduct(data: any) {
    return (this.http.post(`${environment.apiUrl}/mmpp-products`, data));
  }

  getMmppProductById(id: number) {
    return (this.http.get(`${environment.apiUrl}/mmpp-products/${id}`));
  }

  updateMmppProduct(data: any) {
    return (this.http.put(`${environment.apiUrl}/mmpp-products/${data.id}`, data));
  }

  deleteMmppProduct(id: number): Observable<any> {
    return (this.http.delete(`${environment.apiUrl}/mmpp-products/${id}`));
  }
}
